import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=f036957e&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f036957e')) {
      api.createRecord('f036957e', component.options)
    } else {
      api.reload('f036957e', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=f036957e&", function () {
      api.rerender('f036957e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29EGi5vnWhBH5/JS/comp/ImgFallback.vue"
export default component.exports